<template>
  <div class="pedido-listado">
    <section class="pedido-steps">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <div class="return d-block d-sm-none">
              <router-link :to="route + 'skus'">
                <img
                  :src="require('@/assets/img/backspace.svg')"
                  class="mb-5"
                  alt="backspace"
                />
              </router-link>
            </div>
            <div class="section-title">
              <h4>Alta / Edición SKU</h4>
              <router-link :to="route + 'skus'">
                <img
                  class="d-none d-sm-block"
                  :src="require('@/assets/img/backspace.svg')"
                  alt="backspace"
                />
              </router-link>
            </div>
          </div>
        </div>

        <div class="row mt-3">
          <div class="col-12">
            <div v-if="stage === 'lookup'" class="d-flex flex-column align-items-start">
              <label class="form-label mt-2">Ingrese EAN (code_value)</label>
              <div class="input-group w-100">
                <input
                  v-model="ean"
                  class="input-filter form-control mr-2"
                  placeholder="EAN"
                  aria-label="EAN"
                  :disabled="loading"
                />
                <select
                  v-if="availableCodeKeys && availableCodeKeys.length > 1"
                  v-model="codeKey"
                  class="custom-select"
                  :required="true"
                  :disabled="loading"
                  aria-label="Seleccionar reference code"
                >
                  <option value="">Seleccione reference code</option>
                  <option v-for="ck in availableCodeKeys" :key="ck.value" :value="ck.value">{{ ck.label }}</option>
                </select>
              </div>
              <button
                class="btn-green mx-0 mt-3"
                type="button"
                @click="lookupEan"
                :disabled="loading"
              >
                Buscar
              </button>
              <div v-if="message" class="text-danger" style="margin-top: 8px">
                {{ message }}
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-12">
            <div v-if="stage === 'form'">
              <form @submit.prevent="save" class="pedido-steps-form">
                <div class="row">
                  <div class="col-md-6 col-sm-12">
                    <label class="form-label mt-2">EAN *</label>
                    <input
                      v-model="form.codes[this.codeKey]"
                      :readonly="readonlyFields.code_value"
                      class="form-control"
                    />
                    <div v-if="availableCodeKeys && availableCodeKeys.length > 1" class="mt-2">
                      <label class="form-label">Reference code</label>
                      <input :value="codeKeyLabel" readonly class="form-control" />
                    </div>
                  </div>
                  <div class="col-md-6 col-sm-12">
                    <label class="form-label mt-2">Código SAP *</label>
                    <input
                      v-model="form.description4"
                      :readonly="readonlyFields.description4"
                      class="form-control"
                    />
                  </div>
                </div>

                <div class="row mt-2">
                  <div class="col-md-6 col-sm-12">
                    <label class="form-label">Nombre *</label>
                    <input v-model="form.name" class="form-control" />
                  </div>
                  <div class="col-md-6 col-sm-12">
                    <label class="form-label">Status WOE *</label>
                    <select v-model="form.description1" class="form-select">
                      <option :value="'TRUE'">Habilitado</option>
                      <option :value="'FALSE'">Deshabilitado</option>
                    </select>
                  </div>
                </div>

                <div class="row mt-2">
                  <div class="col-md-6 col-sm-12">
                    <label class="form-label">Bolsas por caja *</label>
                    <input
                      v-model="form.sellingQuantities"
                      class="form-control"
                    />
                  </div>
                  <div class="col-md-6 col-sm-12">
                    <label class="form-label">Peso neto caja (kg) *</label>
                    <input v-model="form.numberOfUnits" class="form-control" />
                  </div>
                </div>

                <div class="row mt-2">
                  <div class="col-md-6 col-sm-12">
                    <label class="form-label">Volumen caja (cm³) *</label>
                    <input v-model="form.description10" class="form-control" />
                  </div>
                  <div class="col-md-6 col-sm-12">
                    <label class="form-label">Peso bruto caja (kg) *</label>
                    <input v-model="form.description12" class="form-control" />
                  </div>
                </div>

                <div class="row mt-2">
                  <div class="col-md-6 col-sm-12">
                    <label class="form-label">Cajas por pallet *</label>
                    <input v-model="form.description5" class="form-control" />
                  </div>
                  <div class="col-md-6 col-sm-12"></div>
                </div>

                <div v-if="hasSalesUnits" class="row mt-2">
                  <div class="col-md-6 col-sm-12">
                    <label class="form-label">Unidad de venta 1 *</label>
                    <select v-model="form.description19" class="form-select">
                      <option value="">Seleccione</option>
                      <option v-for="unit in salesUnits" :key="unit" :value="unit">{{ unit }}</option>
                    </select>
                  </div>
                  <div class="col-md-6 col-sm-12">
                    <label class="form-label">Unidad de venta 2 *</label>
                    <select v-model="form.description20" class="form-select">
                      <option value="">Seleccione</option>
                      <option v-for="unit in salesUnits" :key="unit" :value="unit">{{ unit }}</option>
                    </select>
                  </div>
                </div>

                <div v-if="isColombia" class="row mt-2">
                  <div class="col-md-6 col-sm-12">
                    <label class="form-label">Despliegue *</label>
                    <select v-model="form.description21" class="form-select">
                      <option value="">Seleccione</option>
                      <option value="UNITARIO">Unitario</option>
                      <option value="MULTIPLO">Múltiplo</option>
                    </select>
                  </div>
                  <div class="col-md-6 col-sm-12"></div>
                </div>

                <div class="next-btn mt-3">
                  <button type="submit" class="btn-green" :disabled="loading">
                    Guardar
                  </button>
                  <button type="button" class="btn-white" @click="cancel">
                    Cancelar
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <div class="loading" v-if="loading"></div>
    </section>
    <vue-basic-alert :duration="300" :closeIn="5000" ref="alert" />
    <ConfirmModal ref="confirm" />
  </div>
</template>

<script>
import { route } from "../../enviroment.js";
import skuService from "../../services/skuService";
import { redirectWithFlash } from "../../utils/flashAlert";
import ConfirmModal from "../shared/ConfirmModal.vue";

const NUMERIC_FIELD_LABELS = {
  sellingQuantities: "Bolsas por caja",
  numberOfUnits: "Peso neto caja (kg)",
  description10: "Volumen caja (cm³)",
  description12: "Peso bruto caja (kg)",
  description5: "Cajas por pallet",
};

const SALES_UNITS = ["CS", "EA"];

// Legacy SKUs may hold free text; show them as unselected so the user must pick a valid unit.
function toSalesUnit(value) {
  const unit = String(value || "").trim().toUpperCase();
  return SALES_UNITS.includes(unit) ? unit : "";
}

export default {
  name: "SkuForm",
  components: { ConfirmModal },
  data() {
    return {
      route: route,
      stage: "lookup", // 'lookup' | 'form'
      ean: this.$route.query.ean || "",
      message: "",
      loading: false,
      form: {
        id: null,
        codes: {},
        description4: "",
        name: "",
        description1: "TRUE",
        sellingQuantities: "",
        numberOfUnits: "",
        description10: "",
        description12: "",
        description5: "",
        description19: "",
        description20: "",
        description21: "",
      },
      codeKey: this.$route.query.codeKey || "",
      readonlyFields: { code_value: false, description4: false },
      availableCodeKeys: [],
      salesUnits: SALES_UNITS,
    };
  },
  computed: {
    isColombia() {
      const country = sessionStorage.getItem("country") || "";
      return country.toLowerCase().includes("colombia");
    },
    isUruguay() {
      const country = sessionStorage.getItem("country") || "";
      return country.toLowerCase().includes("uruguay");
    },
    hasSalesUnits() {
      return this.isColombia || this.isUruguay;
    },
    codeKeyLabel() {
      if (!this.codeKey) return "";
      if (!this.availableCodeKeys) return this.codeKey;
      const found = this.availableCodeKeys.find(
        (ck) => (ck && ck.value !== undefined ? ck.value === this.codeKey : ck === this.codeKey)
      );
      if (!found) return this.codeKey;
      return found.label !== undefined ? found.label : found;
    },
  },
  async created() {
    // load code keys first so we can set default or show selector
    await this.getCodeKeys();
    if (this.ean) {
      // auto lookup if ean passed via query
      this.lookupEan();
    }
  },
  methods: {
    showAlert(type, title, message) {
      this.$refs.alert.showAlert(type, message, title, {
        iconSize: 35,
        iconType: "solid",
        position: "top right",
      });
    },
    async lookupEan() {
      if (this.loading) return;
      this.loading = true;
      if (!this.ean) {
        this.message = "Ingrese un EAN para buscar.";
        this.loading = false;
        return;
      }
      // if multiple codeKeys exist, require selection
      if (this.availableCodeKeys && this.availableCodeKeys.length > 1 && !this.codeKey) {
        this.message = "Seleccione un codeKey antes de buscar.";
        this.loading = false;
        return;
      }
      this.message = "";
      try {
        const resp = await skuService.getSkuByCodeValue(this.ean, this.codeKey);
        const data = resp.data.data;
        const sku = data.sku;
        this.codeKey = data.codeKey;
        if (!sku) {
          this.startCreate();
          return;
        }

        // if sku exists, check active state
        if (sku.active === false) {
          this.message =
            "El SKU ingresado existe pero está inactivo. Por favor, contacte al representante de Thalamus.";
          this.stage = "lookup";
          return;
        }

        // active -> load form for edit
        this.setForm(sku, data.codeKey);
        this._original = JSON.parse(JSON.stringify(this.form));
        this.readonlyFields.code_value = true;
        this.readonlyFields.description4 = true;
        this.stage = "form";
      } catch (err) {
        // if 404 treat as not found, else show error
        if (err.response && err.response.status === 404) {
          this.startCreate();
        } else {
          console.error(err);
          this.message = "Error al consultar EAN.";
        }
      } finally {
        this.loading = false;
      }
    },
    startCreate() {
      this.stage = "form";
      this.form = Object.assign({}, this.form, {
        codes: Object.assign({}, this.form.codes, { [this.codeKey]: this.ean }),
      });
      this.readonlyFields.code_value = true;
      this.readonlyFields.description4 = false;
    },
    cancel() {
      sessionStorage.removeItem("flash");
      this.$router.push(this.route + "skus");
    },
    async save() {
      if (this.loading) return;
      this.loading = true;
      const required = [
        "name",
        "description4",
        "sellingQuantities",
        "numberOfUnits",
        "description10",
        "description12",
        "description5",
      ];
      for (const f of required) {
        if (!this.form[f]) {
          this.showAlert(
            "warning",
            "Atención",
            "Complete todos los campos obligatorios antes de guardar."
          );
          this.loading = false;
          return;
        }
      }
      const commaField = Object.keys(NUMERIC_FIELD_LABELS).find((f) =>
        String(this.form[f]).includes(",")
      );
      if (commaField) {
        this.showAlert(
          "warning",
          "Atención",
          `El campo ${NUMERIC_FIELD_LABELS[commaField]} debe usar punto (.) como separador decimal en lugar de coma (,). Ejemplo: 1.5`
        );
        this.loading = false;
        return;
      }
      // require EAN present in codes.newCode
      if (!this.form.codes || !this.form.codes[this.codeKey]) {
        this.showAlert(
          "warning",
          "Atención",
          "Ingrese un EAN antes de guardar."
        );
        this.loading = false;
        return;
      }

      if (this.hasSalesUnits) {
        const requiredByCountry = this.isColombia
          ? ["description19", "description20", "description21"]
          : ["description19", "description20"];
        for (const f of requiredByCountry) {
          if (!this.form[f]) {
            this.showAlert(
              "warning",
              "Atención",
              `Campos de ${this.isColombia ? "Colombia" : "Uruguay"} obligatorios. Complete antes de guardar.`
            );
            this.loading = false;
            return;
          }
        }
      }

      if (this.form.id) {
        if (
          this._original &&
          this._original.description1 !== undefined &&
          this._original.description1 !== this.form.description1
        ) {
          const ok = await this.$refs.confirm.open(
            "Confirmar",
            "¿Está seguro de que desea habilitar o deshabilitar el SKU para WOE?",
            { confirmText: "Aceptar", cancelText: "Cancelar" }
          );
          if (!ok) {
            this.loading = false;
            return;
          }
        }
      }

      try {
        if (this.form.id) {
          await skuService.updateSku(this.form.codes[this.codeKey], this.form);
          redirectWithFlash(this.$router, this.route + "skus", {
            type: "success",
            title: "Éxito",
            msg: "SKU actualizado correctamente",
          });
        } else {
          await skuService.createSku(this.form);
          redirectWithFlash(this.$router, this.route + "skus", {
            type: "success",
            title: "Éxito",
            msg: "SKU creado correctamente",
          });
        }
      } catch (err) {
        console.error(err);
        this.showAlert("error", "Error", this.getSaveErrorMessage(err));
        this.loading = false;
      }
    },
    getSaveErrorMessage(err) {
      const errors =
        err.response && err.response.status === 422 && err.response.data
          ? err.response.data.errors
          : null;
      if (errors) {
        const firstField = Object.keys(errors)[0];
        if (firstField && errors[firstField].length) {
          return errors[firstField][0];
        }
      }
      return "Error al guardar SKU";
    },
    setForm(sku, codeKey) {
      this.form = {
        id: sku.id,
        codes: {
          [codeKey]: sku.codes[codeKey],
        },
        description4: sku.description4,
        name: sku.name,
        description1: sku.description1.toUpperCase(),
        sellingQuantities: sku.sellingQuantities,
        numberOfUnits: sku.numberOfUnits,
        description10: sku.description10,
        description12: sku.description12,
        description5: sku.description5,
        description19: toSalesUnit(sku.description19),
        description20: toSalesUnit(sku.description20),
        description21: sku.description21,
      };
    },
    async getCodeKeys() {
      try {
        this.loading = true;
        const res = await skuService.getCodeKeys();
        this.availableCodeKeys = res.data.data.codeKeys;
        // if only one codeKey, set it by default (handle objects or strings)
        if (this.availableCodeKeys && this.availableCodeKeys.length === 1) {
          const first = this.availableCodeKeys[0];
          this.codeKey = first && first.value !== undefined ? first.value : first;
        }
        this.loading = false;
      } catch (err) {
        console.error(err);
        this.showAlert("error", "Error", "Error al obtener Code Keys");
        this.loading = false;
      }
    },
  },
};
</script>
